import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

import { hexToHSL } from '../label/hex-to-hsl-converter';

@Component({
  selector: 'itl-info-modal',
  templateUrl: './info-modal.component.html',
  styleUrls: ['./info-modal.component.scss'],
})
export class InfoModalComponent implements OnInit {
  @Input() baseColor: string;
  @Input() header: string;
  @Input() message: string;

  public infoStyle: string;
  public iconStyle: string;

  constructor(private _modalController: ModalController) {}

  ngOnInit() {
    this.setStyle();
  }

  public async close() {
    await this._modalController.dismiss().catch(error => console.log(error));
  }

  private setStyle() {
    const hsl = hexToHSL(this.baseColor);
    const hslPrefix = 'hsl(' + hsl.hue + ',' + hsl.saturation + '%,';
    this.infoStyle = `
      background-color: ${hslPrefix}95%);
    `;
    this.iconStyle = `color: ${hslPrefix}${hsl.lightness}%)`;
  }
}
